import { Injectable } from '@angular/core'
import { LoginService } from '../services/login.service'
import { NavbarService } from 'src/app/layout/services/navbar.service'

@Injectable({
  providedIn: 'root',
})
export class AuthGuardTwo {
  constructor(
    private loginService: LoginService,
    private navbarService: NavbarService,
  ) {}

  canActivate(): boolean {
    if (this.loginService.tokenLevel() === '50' && this.loginService.loggedIn()) {
      return true
    } else {
      this.navbarService.logout()
      return false
    }
  }
}
